/* © 2026 Trinchebalk */
(() => {
  if (customElements.get('tb-a-product')) return;
  // Explicit storefront correspondences, audited against docs/k1/opciones-reales.txt.
  // Keys are component/parent variant IDs, never translated labels or fuzzy matches.
  const kitSocks = {
    '49266189730128': 'Blanco', '49362653708624': 'Negro Finos', '49362653741392': 'Negro Gruesos',
    '48652741083472': 'V2 Azul Marino', '48652741116240': 'V2 Rojo',
    '48652741149008': 'V2 Amarillo', '48652741181776': 'V2 Verde'
  };
  const kitPads = {
    "51013224104272": "WHITE 8 CM",
    "51013224137040": "WHITE 10 CM",
    "51013224169808": "WHITE 12 CM",
    "51013216764240": "BLACK 8 CM",
    "51013216797008": "BLACK 10 CM",
    "51013216829776": "BLACK 12 CM",
    "49362644205904": "AQUA 8 CM",
    "49122744303952": "AQUA 10 CM",
    "49122744336720": "AQUA 12 CM",
    "52534588506448": "CARBON LOOK 10 CM",
    "52462474494288": "CARBON LOOK 10 CM",
    "51112084865360": "BLACK 8 CM",
    "51112084898128": "BLACK 10 CM",
    "51112084930896": "BLACK 12 CM",
    "51112084963664": "WHITE 8 CM",
    "51112084996432": "WHITE 10 CM",
    "51112085029200": "WHITE 12 CM",
    "51253583905104": "EVA GOAT 9 CM",
    "51253583937872": "EVA GOAT 15 CM",
    "49362651578704": "PINK 8 CM",
    "48218887192912": "PINK 10 CM",
    "48218887225680": "PINK 12 CM",
    "49362651611472": "AQUA 8 CM",
    "49122754232656": "AQUA 10 CM",
    "49122754265424": "AQUA 12 CM",
    "49122754298192": "EVA AQUA 9 CM",
    "49122754330960": "EVA AQUA 15 CM",
    "49362646597968": "PINK 8 CM",
    "48658328387920": "PINK 10 CM",
    "48658328355152": "PINK 12 CM"
};
  const kitPrecuts = {
    '48652742918480': 'Negro 2.0', '48652742951248': 'Blanco 2.0',
    '48652742984016': 'V2 Rojo', '48652743016784': 'V2 Azul Marino',
    '48652743049552': 'V2 Azul Francia', '48652743082320': 'V2 Amarillo', '48652743115088': 'V2 Verde'
  };
  const kitShortSocks = {
    '48192423067984': 'Azul Marino', '48192423100752': 'Amarillo',
    '48192423133520': 'Rojo', '48192423166288': 'Verde'
  };
  // Display keys never shadow a Simple Bundles group read by the stock validator.
  const kitPropertyNames = {
    'Mini Espinilleras': 'pads', 'Calcetines Antideslizantes': 'socks1',
    'REGALO - Calcetines Antideslizantes': 'socks2', 'Medias Cortadas': 'sleeves',
    'Calcetines Cortos': 'short', '1er Par': 'pair1', '50% OFF - 2do Par': 'pair2'
  };
  // Ordered group contracts audited for each parent. Position is accepted only
  // when the live v2 group name and shape match this stable contract.
  const kitProfiles = {
    '48670324097360': { groups: ['Mini Espinilleras', 'Calcetines Antideslizantes', 'REGALO - Calcetines Antideslizantes'], types: ['pad', 'sock', 'sock'], sockPrefix: 'Calcetines Antideslizantes - ' },
    '51579172225360': { groups: ['Calcetines Antideslizantes'], types: ['sock'] },
    '51579172258128': { groups: ['Calcetines Antideslizantes'], types: ['sock'] },
    '51579172290896': { groups: ['Calcetines Antideslizantes'], types: ['sock'] },
    // Luis confirmed Mystery's white component = Blanco Finos.
    '52014012072272': { groups: ['Mini Espinilleras', 'Calcetines Antideslizantes', 'REGALO - Calcetines Antideslizantes'], types: ['pad', 'sock', 'sock'], white: 'Blanco Finos' },
    '49063464632656': { groups: ['1er Par', '50% OFF - 2do Par'], types: ['pad', 'pad'] },
    '48218891944272': { groups: ['Mini Espinilleras', 'Calcetines Antideslizantes', 'Medias Cortadas', 'Calcetines Cortos'], types: ['pad', 'sock', 'precut', 'short'], sockPrefix: 'Calcetines Antideslizantes - ', padPrefix: 'Mini Espinilleras - ' }
  };
  class Product extends HTMLElement {
    connectedCallback() {
      try { this.initialize(); }
      catch (error) {
        this.dataset.initError = 'true';
        clearInterval(this.etaTimer);
        this.form ||= this.querySelector('.tbp-form');
        if (this.submitHandler) this.form?.removeEventListener('submit', this.submitHandler);
        // Standard products retain the native Shopify form, including its variant ID.
        // Kits and custom designs still need their validated configuration.
        const add = this.querySelector('[data-add]');
        const sticky = this.querySelector('[data-sticky]');
        if (add) add.disabled = true;
        if (sticky) sticky.disabled = true;
        if (add && this.dataset.custom !== 'true' && this.dataset.kind !== 'kit') {
          add.disabled = Boolean(this.querySelector('[data-option]')) || (this.variant ? !this.variant.available : this.form?.elements.id?.dataset.available !== 'true');
          if (sticky) { sticky.disabled = add.disabled; sticky.onclick = () => add.click(); }
          if (this.config?.variants) {
            const syncVariant = () => {
              const options = [...this.querySelectorAll('[data-option]')].map(group => group.querySelector('input:checked')?.value);
              const variant = this.config.variants.find(v => options.every((value, i) => v.options[i] === value));
              if (variant) this.form.elements.id.value = variant.id;
              add.disabled = !variant?.available;
              if (sticky) sticky.disabled = add.disabled;
            };
            this.addEventListener('change', syncVariant); syncVariant();
          }
        }
      }
    }
    initialize() {
      if (this.ready) return; this.ready = true;
      document.body.classList.add('tb-has-sticky');
      this.config = JSON.parse(this.querySelector('[data-product-config]').textContent);
      this.form = this.querySelector('.tbp-form'); this.busy = false;
      const packs = this.querySelector('[data-pack-selector]'); if (packs && this.dataset.currency !== 'EUR') packs.hidden = true;
      // Mismo formato que Liquid `money` (shop.money_format): el precio no cambia de forma al cargar el JS.
      this.moneyCurrency = this.dataset.currency;
      this.money = cents => {
        const format = this.dataset.currency === this.dataset.shopCurrency ? this.dataset.moneyFormat : null;
        // Liquid's market-aware sample preserves currency position, separators and spacing.
        const sample = this.dataset.currency === this.moneyCurrency && this.dataset.moneySample;
        const numeric = sample && sample.match(/[0-9][0-9.,'’\s]*/)?.[0].trim();
        if (numeric) {
          const decimals = /[.,]56$/.test(numeric), separator = decimals ? numeric.at(-3) : '';
          const grouping = numeric.match(/^1(\D)23[45]/)?.[1];
          let [whole, fraction] = (cents / 100).toFixed(decimals ? 2 : 0).split('.');
          if (grouping) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, grouping);
          return sample.replace(numeric, whole + (decimals ? separator + fraction : ''));
        }
        if (!format) return new Intl.NumberFormat(this.dataset.locale || 'it-IT', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
        const n = cents / 100, r = Math.round(n), dec = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
        const map = {
          amount: n.toLocaleString('en-US', dec), amount_no_decimals: r.toLocaleString('en-US'),
          amount_with_comma_separator: n.toLocaleString('de-DE', dec), amount_no_decimals_with_comma_separator: r.toLocaleString('de-DE'),
          amount_with_apostrophe_separator: n.toLocaleString('en-US', dec).replace(/,/g, "'"),
          amount_with_space_separator: n.toLocaleString('de-DE', dec).replace(/\./g, ' '), amount_no_decimals_with_space_separator: r.toLocaleString('de-DE').replace(/\./g, ' '),
          amount_with_period_and_space_separator: n.toLocaleString('en-US', dec).replace(/,/g, ' ')
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => map[key] ?? map.amount);
      };
      this.gallery();
      if(this.dataset.custom === 'true') this.localCover();
      this.siblings();
      this.addEventListener('change', () => { if (this.dataset.initError !== 'true') this.update(); });
      this.addEventListener('click',async e=>{const b=e.target.closest('[data-leg]');if(!b||b.disabled)return;b.disabled=true;b.setAttribute('aria-busy','true');const label=b.innerHTML;try{await(await import(window.TBStudioAssets?.['tb-a-leg.js']||b.dataset.leg)).open(b)}catch{b.textContent=b.dataset.legError;setTimeout(()=>b.innerHTML=label,4000)}finally{b.disabled=false;b.removeAttribute('aria-busy')}});
      this.addEventListener('tb:editor:change', () => this.guard());
      this.addEventListener('change', () => this.querySelectorAll('[data-missing]').forEach(el => delete el.dataset.missing));
      this.querySelector('[data-sticky]').addEventListener('click', () => {
        if (this.dataset.initError === 'true') return;
        const missing = this.missingOption();
        if (missing) { this.markMissing(missing); return; }
        if (this.dataset.custom === 'true') {
          const editor = this.querySelector('tb-a-editor');
          window.TBOpenStudio?.(editor);
          return;
        }
        if (this.form.requestSubmit) this.form.requestSubmit();
        else this.querySelector('[data-add]').click();
      });
      // La barra fija sigue al botón real mediante scroll, resize y observers.
      // Los eventos mantienen el fallback en webviews sin IntersectionObserver.
      const sticky = this.querySelector('.tbp-sticky'), add = this.querySelector('[data-open-studio]') || this.querySelector('[data-add]');
      let pending = 0;
      const measure = () => {
        pending = 0;
        const r = add.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
        // The real button counts only once it can be tapped above the bar's own footprint.
        const floor = vh - sticky.offsetHeight - (parseFloat(getComputedStyle(sticky).bottom) || 0);
        const visible = r.height > 0 && r.bottom > 0 && r.top + r.height / 2 < floor;
        sticky.classList.toggle('is-hidden', visible);
        sticky.inert = visible;
      };
      const ask = () => { if (!pending) pending = requestAnimationFrame(measure); };
      addEventListener('scroll', ask, { passive: true }); addEventListener('resize', ask, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(ask).observe(add);
      if ('ResizeObserver' in window) new ResizeObserver(ask).observe(this);
      this.addEventListener('tb:editor:change', ask); document.fonts.ready.then(ask); measure();
      this.eta();
      this.extraRows = window.TBExtras?.init(this, this.money, () => this.update()) || [];
      const extras = this.querySelector('[data-pdp-upsell]');
      if (extras && this.extraRows.length) { extras.dataset.extraReady = ''; extras.hidden = false; }
      this.update();
      this.querySelectorAll('[data-guide]').forEach(b => b.addEventListener('click', () => this.querySelector('.tbp-dialog').showModal()));
      this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
      this.submitHandler = e => this.submit(e);
      this.form.addEventListener('submit', this.submitHandler);
      this.enhanceKit();
      this.update();
    }
    update() {
      const options = [...this.querySelectorAll('[data-option]')].map(group => group.querySelector('input:checked')?.value);
      this.variant = this.config.variants.find(v => options.every((value, i) => v.options[i] === value));
      this.quantity = Math.max(1, Math.min(99, Number(new FormData(this.form).get('quantity')) || 1));
      if (!this.variant) { this.guard(); return; }
      if (this.form.elements.id.value !== String(this.variant.id)) this.form.elements.id.value = this.variant.id;
      const size = this.querySelector('[data-size-value]'); if (size) size.value = this.variant.title;
      this.querySelector('tb-a-editor')?.setSize?.(this.variant.title);
      this.querySelector('tb-a-editor')?.r2?.variantChanged();
      this.querySelector('[data-price]').textContent = this.money(this.variant.price);
      const compare = this.querySelector('[data-compare]'); if (compare) { compare.hidden = !(this.variant.compare_at_price > this.variant.price); compare.textContent = this.money(this.variant.compare_at_price || 0); }
      this.updateExtra();
      const total = this.packPrice(this.quantity) + this.selectedExtras().reduce((sum, v) => sum + v.price, 0);
      this.querySelectorAll('[data-total]').forEach(el => { el.textContent = this.money(total); });
      this.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = this.money(this.packPrice(Number(el.dataset.packPrice))); });
      const stock = this.querySelector('[data-stock]');
      stock.textContent = this.variant.available ? this.config.strings.available : this.config.strings.sold_out;
      stock.parentElement.classList.toggle('is-out', !this.variant.available);
      const media = this.config.variantMedia?.[this.variant.id] ?? this.variant.featured_media?.id ?? this.variant.featured_image?.id;
      if (media && media !== this.media) { this.media = media; this.showSlide?.(media); }
      this.updateKit(); this.guard();this.syncLocalCover?.();
    }
    gallery() {
      const track = this.querySelector('[data-gallery]'); if (!track) return;
      const slides = track.children, thumbs = () => [...this.querySelectorAll('.tbp-thumbs [data-thumb]')], index = this.querySelector('[data-gallery-index]');
      const smooth = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.showSlide = (id, behavior = 'instant') => { const slide = [...slides].find(s => s.dataset.slide == id); if (slide) track.scrollTo({ left: slide.offsetLeft, behavior }); };
      this.querySelector('.tbp-thumbs')?.addEventListener('click', e => {const b=e.target.closest('[data-thumb]');if(b)this.showSlide(b.dataset.thumb,smooth());});
      let frame = 0;
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(() => {
        frame = 0; const i = Math.round(track.scrollLeft / (track.clientWidth || 1)), id = slides[i]?.dataset.slide;
        thumbs().forEach(b => b.setAttribute('aria-pressed', b.dataset.thumb === id)); if (index) index.textContent = i + 1;
      }); }, { passive: true });
    }
    localCover() {
      const track=this.querySelector('[data-gallery]'), sticky=this.querySelector('.tbp-sticky-product img');if(!track)return;
      const original=sticky?{src:sticky.src,srcset:sticky.getAttribute('srcset'),alt:sticky.alt}:null;
      let epoch=0;
      const sync=async()=>{const serial=++epoch,r=await window.TBLocalDesign?.latest(this.dataset.productId,this.variant?.id);if(serial!==epoch)return;
        if(r){try{const im=new Image();im.src=r.url;await im.decode();}catch(_){return;}if(serial!==epoch)return;}
        let slide=track.querySelector('[data-local-cover]'),thumb=this.querySelector('[data-local-thumb]');
        if(!r){slide?.remove();thumb?.remove();if(sticky&&original){delete sticky.parentElement.querySelector('span')?.dataset.localDesignLabel;sticky.src=original.src;sticky.alt=original.alt;if(original.srcset)sticky.srcset=original.srcset;}this.coverCount();return;}
        if(!slide){slide=document.createElement('div');slide.dataset.slide='local';slide.dataset.localCover='';const img=document.createElement('img');img.width=img.height=360;slide.append(img);const badge=document.createElement('span');badge.className='tbp-design-badge';slide.append(badge);track.prepend(slide);
          thumb=document.createElement('button');thumb.type='button';thumb.dataset.thumb='local';thumb.dataset.localThumb='';thumb.append(document.createElement('img'));const strip=this.querySelector('.tbp-thumbs');strip?.prepend(thumb);if(strip)strip.scrollLeft=0;track.scrollLeft=0;
        }
        slide.querySelector('img').src=r.url;slide.querySelector('img').alt=window.TBLocalDesign.label();slide.querySelector('span').textContent=window.TBLocalDesign.label();
        thumb.querySelector('img').src=r.url;thumb.querySelector('img').alt='';thumb.setAttribute('aria-label',window.TBLocalDesign.label());
        if(sticky){sticky.removeAttribute('srcset');sticky.src=r.url;sticky.alt=window.TBLocalDesign.label();const title=sticky.parentElement.querySelector('span');if(title)title.dataset.localDesignLabel=window.TBLocalDesign.label();}
        this.coverCount();
      };
      document.addEventListener('tb:local-design',sync);this.syncLocalCover=sync;sync();
    }
    coverCount(){const track=this.querySelector('[data-gallery]'),i=Math.round(track.scrollLeft/(track.clientWidth||1)),id=track.children[i]?.dataset.slide,count=this.querySelector('.tbp-gallery-count');this.querySelectorAll('.tbp-thumbs [data-thumb]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.thumb===id));if(count){const index=this.querySelector('[data-gallery-index]');count.replaceChildren(index,document.createTextNode(' / '+track.children.length));index.textContent=i+1;}}
    siblings() {
      const strip = this.querySelector('[data-siblings]'); if (!strip) return;
      const current = strip.querySelector('[aria-current]');
      if (current && strip.scrollWidth > strip.clientWidth) strip.scrollLeft = current.offsetLeft - (strip.clientWidth - current.offsetWidth) / 2;
      strip.addEventListener('click', e => { if (e.target.closest('[aria-current]')) e.preventDefault(); });
      // Warm the destination cover with the same srcset/sizes its gallery will request.
      const warm = e => {
        const link = e.target.closest('[data-sib]:not([aria-current])'); if (!link || link.warm) return; link.warm = true;
        const preload = Object.assign(document.createElement('link'), { rel: 'preload', as: 'image' });
        preload.setAttribute('imagesrcset', link.dataset.srcset); preload.setAttribute('imagesizes', '(min-width: 990px) 50vw, 100vw'); document.head.append(preload);
      };
      strip.addEventListener('pointerdown', warm, { passive: true }); strip.addEventListener('touchstart', warm, { passive: true });
      // Cross-document view transition: the tapped cover morphs into the next main image.
      const hero = this.querySelector('[data-gallery] img'), name = (el, value) => { if (el) el.style.viewTransitionName = value; };
      addEventListener('pageswap', e => {
        const url = e.activation?.entry?.url, link = url && [...strip.querySelectorAll('[data-sib]')].find(a => a.href === url);
        if (e.viewTransition && link) { name(hero, 'none'); name(link.querySelector('img'), 'tbp-hero'); }
      });
      addEventListener('pagereveal', e => Promise.resolve(e.viewTransition?.finished).catch(() => {}).then(() => { name(hero, ''); strip.querySelectorAll('img').forEach(img => name(img, '')); }));
    }
    enhanceKit() {
      // The native select owns every choice. Covers only send the same change event
      // as a customer using that select; all contract/price/stock logic stays below.
      this.kitViews = [];
      this.querySelectorAll('[data-kit-pad],[data-kit-sock],[data-kit-generic]').forEach(select => {
        const options = [...select.options];
        const shortModel = title => title.replace(/^Mini[\s-]+(?:Parastinchi|Schienbeinschoner|Prot[eè]ge-?tibias|Espinilleras|Shin\s*(?:Guards?|Pads?)|Scheenbeschermers?|Caneleiras)\s*/i, '').replace(/\s+\d+\s*cm$/i, '').trim();
        const choices = options.map(option => {
          const title = option.dataset.choiceLabel || option.textContent.trim();
          const match = title.match(/^(.*?)\s*(\d+\s*cm)$/i);
          const size = option.dataset.size || match?.[2];
          const model = option.dataset.model || (size ? match?.[1] || option.dataset.choiceProduct : '');
          return { option, size, model, label: shortModel(option.dataset.modelLabel || model || title) };
        });
        const pads = choices.some(c => c.size && c.model);
        const box = document.createElement('div'); box.className = pads ? 'tbp-kit-choices' : 'tbp-kit-swatches';
        const models = [...new Set(choices.map(c => c.model))];
        if (pads && models.length > 5) box.dataset.kitMany = '';
        const choose = option => {
          if (!option || option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        };
        const cover = (option, index, pad) => {
          if (!option.dataset.image || option.dataset.image.startsWith('?')) return null;
          const img = document.createElement('img'); img.src = option.dataset.image; img.alt = '';
          img.width = Number(option.dataset.imageWidth) || (pad ? 44 : 42);
          img.height = Number(option.dataset.imageHeight) || (pad ? 55 : 72);
          img.loading = index < (pad && models.length <= 5 ? 5 : 4) ? 'eager' : 'lazy';
          return img;
        };
        const entries = pads ? models.map(model => choices.find(c => c.model === model)) : choices;
        const buttons = entries.map((entry, index) => {
          const button = document.createElement('button'); button.type = 'button';
          if (pads) button.dataset.model = entry.model;
          else button.dataset.sockVariant = entry.option.value;
          const img = cover(entry.option, index, pads); if (img) button.append(img);
          const caption = document.createElement('span'); caption.textContent = entry.label; button.append(caption);
          const status = document.createElement('small'); status.textContent = this.config.strings.sold_out; status.hidden = true; button.append(status);
          button.addEventListener('click', () => {
            const size = choices.find(c => c.option.selected)?.size;
            const next = pads ? choices.find(c => c.model === entry.model && c.size === size && !c.option.disabled) || choices.find(c => c.model === entry.model && !c.option.disabled) : entry;
            choose(next?.option);
          });
          box.append(button); return { button, entry, status };
        });
        let sizes;
        const sizeButtons = [];
        if (pads) {
          sizes = document.createElement('div'); sizes.className = 'tbp-kit-sizes';
          [...new Set(choices.map(c => c.size).filter(Boolean))].sort((a, b) => parseInt(a, 10) - parseInt(b, 10)).forEach(size => {
            const button = document.createElement('button'); button.type = 'button'; button.dataset.kitSize = size; button.textContent = size.replace(/cm/i, 'cm');
            const hint = this.config.strings['size_' + parseInt(size, 10)];
            if (hint) { const small = document.createElement('small'); small.textContent = hint; button.append(small); }
            button.addEventListener('click', () => choose(choices.find(c => c.model === choices.find(c => c.option.selected)?.model && c.size === size && !c.option.disabled)?.option));
            const status = document.createElement('small'); status.textContent = this.config.strings.sold_out; status.hidden = true; button.append(status);
            sizes.append(button); sizeButtons.push({ button, size, status });
          });
        }
        const sync = () => {
          const selected = choices.find(c => c.option.selected);
          buttons.forEach(({ button, entry, status }) => {
            button.disabled = pads ? !choices.some(c => c.model === entry.model && !c.option.disabled) : entry.option.disabled;
            button.setAttribute('aria-pressed', pads ? selected?.model === entry.model : entry.option.selected);
            status.hidden = !button.disabled;
            status.textContent = button.disabled ? this.config.strings.sold_out : '';
            button.setAttribute('aria-label', entry.label + (button.disabled ? ' · ' + this.config.strings.sold_out : ''));
          });
          sizeButtons.forEach(({ button, size, status }) => {
            const available = choices.find(c => c.model === selected?.model && c.size === size);
            button.hidden = !available;
            button.disabled = !available || available.option.disabled;
            status.hidden = !button.disabled;
            status.textContent = button.disabled ? this.config.strings.sold_out : '';
            button.setAttribute('aria-pressed', selected?.size === size);
            button.setAttribute('aria-label', size + (button.disabled ? ' · ' + this.config.strings.sold_out : ''));
          });
        };
        // Native buttons provide Tab, Enter and Space. Arrow keys also move within
        // each single-choice row, skipping unavailable options without changing slots.
        [box, sizes].filter(Boolean).forEach(row => row.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          const enabled = [...row.querySelectorAll('button')].filter(b => !b.disabled && !b.hidden);
          const index = enabled.indexOf(document.activeElement); if (index < 0) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : (index + (/Left|Up/.test(event.key) ? -1 : 1) + enabled.length) % enabled.length;
          enabled[next].focus(); enabled[next].click();
        }));
        select.before(box); if (sizes) select.before(sizes);
        select.hidden = true;
        this.kitViews.push(sync); sync();
      });
    }
    eta() {
      const el = this.querySelector('[data-eta]'), slot = this.querySelector('[data-eta-slot]');
      clearInterval(this.etaTimer);
      if (slot) slot.hidden = true;
      if (this.config.etaEnabled === false || (this.config.etaScope === 'it' && this.dataset.country !== 'IT')) return;
      if (!el || !slot || !window.TBPDelivery || !this.config.pdp2?.eta) return;
      const refresh = () => {
        const range = window.TBPDelivery.calculate(new Date(), this.dataset.country, this.dataset.custom === 'true', this.config.etaDays);
        const fmt = new Intl.DateTimeFormat(this.dataset.locale, {timeZone:'UTC',weekday:'short',day:'numeric',month:'short'});
        const time = `${Math.floor(range.minutes / 60)}h ${String(range.minutes % 60).padStart(2, '0')}min`;
        const copy = range.active ? this.config.pdp2.eta : (this.config.pdp2.eta_now || this.config.pdp2.eta);
        const values = { time, from: fmt.format(range.from), to: fmt.format(range.to) };
        el.replaceChildren(...copy.split(/(\{\{ (?:time|from|to) \}\})/).map(part => {
          const key = part.match(/^\{\{ (\w+) \}\}$/)?.[1]; if (!key) return part;
          const b = document.createElement('b'); b.className = key === 'time' ? 'tbp-eta-time' : 'tbp-eta-date'; b.textContent = values[key]; return b;
        }));
        slot.hidden = false;
      };
      refresh(); clearInterval(this.etaTimer); this.etaTimer = setInterval(refresh, 1000);
    }
    disconnectedCallback() { clearInterval(this.etaTimer); }
    selectedExtras() {
      return (this.extraRows || []).filter(row => row.querySelector('[data-extra-toggle]').checked)
        .map(row => window.TBExtras.selected(row)).filter(Boolean);
    }
    updateExtra() {
      (this.extraRows || []).forEach(row => window.TBExtras.update(row, this.money));
    }
    standardItems(items) {
      if (this.batchRequest) return this.batchRequest;
      this.batchRequest = this.performStandardItems(items).finally(() => { this.batchRequest = null; });
      return this.batchRequest;
    }
    async performStandardItems(items) {
      const key = 'tb-pdp-batch:' + this.dataset.productId;
      const recoveryKey = key + ':reconcile';
      const release = () => {
        this.pendingBatch = this.batchRecovery = null;
        try { sessionStorage.removeItem(key); sessionStorage.removeItem(recoveryKey); } catch (_) {}
      };
      const fail = () => { const error = new Error(this.config.strings.batch_error); error.cartLink = true; throw error; };
      let pending = this.pendingBatch || this.batchRecovery;
      try {
        const saved = sessionStorage.getItem(key) || sessionStorage.getItem(recoveryKey);
        if (!pending && saved) { try { pending = JSON.parse(saved); } catch (_) { pending = { id: saved, at: 0 }; } }
      } catch (_) {}
      // Keep the last observed batch so a later customer edit is distinguishable
      // from an unchanged partial response. Unobserved legacy records expire too.
      const snapshot = (cart, batch) => JSON.stringify(cart.items
        .filter(line => line.properties?._tb_batch_id === batch.id)
        .map(line => JSON.stringify([String(line.variant_id), line.quantity, Object.entries(line.properties || {}).sort(([a], [b]) => a.localeCompare(b))])).sort());
      const remember = (cart, batch) => {
        batch.observed = snapshot(cart, batch);
        const recovering = this.batchRecovery?.id === batch.id;
        if (!recovering) this.pendingBatch = batch;
        try { sessionStorage.setItem(recovering ? recoveryKey : key, JSON.stringify(batch)); } catch (_) {}
      };
      if (pending && Date.now() - pending.at >= 30 * 60000) { release(); pending = null; }
      const complete = (cart, batch) => {
        const expected = new Map(), actual = new Map();
        for (const item of batch.items || items) expected.set(String(item.id), (expected.get(String(item.id)) || 0) + item.quantity);
        for (const line of cart.items.filter(line => line.properties?._tb_batch_id === batch.id)) actual.set(String(line.variant_id), (actual.get(String(line.variant_id)) || 0) + line.quantity);
        return expected.size === actual.size && [...expected].every(([id, quantity]) => actual.get(id) === quantity);
      };
      if (pending) {
        // Retain partial-response evidence for at most 30 minutes.
        if (Date.now() - pending.at >= 120000) {
          this.batchRecovery = pending; this.pendingBatch = null;
          try { sessionStorage.setItem(recoveryKey, JSON.stringify(pending)); sessionStorage.removeItem(key); } catch (_) {}
        }
        let cart;
        try { cart = await this.readCart(); document.dispatchEvent(new CustomEvent('tb:cart:updated', { detail: cart })); } catch (_) { fail(); }
        if (complete(cart, pending)) { release(); return cart; }
        // Newly arriving lines may be the original delayed POST, not an edit.
        // Only removal/change of an already observed line releases recovery.
        const current = JSON.parse(snapshot(cart, pending));
        const edited = pending.observed !== undefined && JSON.parse(pending.observed).some(line => !current.includes(line));
        if (Date.now() - pending.at < 45000 || (!edited && cart.items.some(line => line.properties?._tb_batch_id === pending.id))) {
          if (!edited) remember(cart, pending);
          fail();
        }
        release();
      }
      const id = crypto.randomUUID();
      this.pendingBatch = { id, at: Date.now(), items: items.map(({ id, quantity }) => ({ id, quantity })) };
      try { sessionStorage.setItem(key, JSON.stringify(this.pendingBatch)); } catch (_) {}
      try {
        await this.addItems(items.map(item => ({ ...item, properties: { ...item.properties, _tb_batch_id: id } })));
        const cart = await this.readCart();
        if (!complete(cart, this.pendingBatch)) throw new Error(this.config.strings.batch_error);
        this.pendingBatch = null;
        try { sessionStorage.removeItem(key); } catch (_) {}
        return cart;
      } catch (cause) {
        // Only a definitive rejection AND an empty batch permit a new POST.
        let cart;
        try { cart = await this.readCart(); document.dispatchEvent(new CustomEvent('tb:cart:updated', { detail: cart })); } catch (_) {}
        if (cart) remember(cart, this.pendingBatch);
        if (cause.rejected && cart && !cart.items.some(line => line.properties?._tb_batch_id === id)) {
          this.pendingBatch = null;
          try { sessionStorage.removeItem(key); } catch (_) {}
          if (items.length > 1) {
            const mainCart = await this.performStandardItems(items.slice(0, 1));
            this.warnExtras(id);
            return mainCart;
          }
          throw cause;
        }
        const error = new Error(cause.rejected ? cause.message : this.config.strings.batch_error); error.cartLink = true; throw error;
      }
    }
    warnExtras(id) {
      this.extraWarnings ||= new Set();
      if (this.extraWarnings.has(id)) return;
      this.extraWarnings.add(id);
      try { const key = 'tb-pdp-extra-warning:' + id; if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, 'shown'); } catch (_) {}
      const notice = this.querySelector('[data-extra-error]');
      if (notice) { notice.textContent = this.config.pdp2.upsell_error; notice.hidden = false; }
      const link = this.querySelector('[data-extra-recover]'); if (link) link.hidden = false;
    }

    async addItems(items) {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', signal: controller.signal, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
        });
        if (!response.ok) {
          let body; try { body = await response.json(); } catch (_) {}
          throw Object.assign(new Error(body?.description || body?.message || this.config.strings.upload_error), { rejected: response.status >= 400 && response.status < 500 });
        }
      } finally { clearTimeout(timer); }
    }
    async customExtraOnce(uploadId, extra, cart) {
      // Only an upload POST reconciled by THIS invocation can authorize an accessory.
      // Recovery/reload never restores this capability. Mark before the network call:
      // a lost response must never cause an automatic duplicate.
      if (!extra?.length) return cart;
      if (this.ownUploadConfirmed !== uploadId) { this.warnExtras(uploadId); return cart; }
      this.ownUploadConfirmed = null;
      this.extraAttempts ||= new Set();
      if (this.extraAttempts.has(uploadId)) { this.warnExtras(uploadId); return cart; }
      this.extraAttempts.add(uploadId);
      const key = 'tb-pdp-extra:' + uploadId;
      try { if (sessionStorage.getItem(key)) { this.warnExtras(uploadId); return cart; } sessionStorage.setItem(key, 'attempted'); } catch (_) {}
      try {
        await this.addItems(extra.map(v => ({ id: v.id, quantity: 1 })));
        return await this.readCart();
      } catch (_) {
        this.warnExtras(uploadId);
        // Refresh if possible, but never remove or re-add the confirmed custom line.
        try { return await this.readCart(); } catch (_) { return cart; }
      }
    }
    packPrice(quantity) { return this.dataset.custom === 'true' && this.querySelector('[data-pack-selector]') && (this.config.packDiscounts || document.body.classList.contains('tb-preview')) && this.dataset.currency === 'EUR' && quantity > 1 && quantity < 4 ? this.config.packPrices[quantity] : this.variant.price * quantity; }
    kitProfile() {
      const embedded = this.querySelector?.('[data-kit-profile]');
      if (!embedded || embedded.textContent.trim() === 'null') return kitProfiles[this.variant?.id] || null;
      try {
        const data = JSON.parse(embedded.textContent);
        const names = new Set(), references = new Set();
        if (data.version !== 1 || !Array.isArray(data.groups) || !data.groups.length || data.groups.length > 6) return null;
        for (const group of data.groups) {
          if (typeof group.name !== 'string' || !group.name.trim() || group.name.startsWith('_') || /[\[\]]/.test(group.name) || names.has(group.name) ||
              !Number.isInteger(group.quantity) || group.quantity < 1 || group.quantity > 10 ||
              !Array.isArray(group.options) || !group.options.length || group.options.length > 40) return null;
          names.add(group.name);
          const ids = new Set(), values = new Set();
          for (const option of group.options) {
            if (typeof option.variant_id !== 'string' || !/^\d+$/.test(option.variant_id) || ids.has(option.variant_id) ||
                typeof option.handle !== 'string' || !/^[a-z0-9-]+$/.test(option.handle) ||
                typeof option.value !== 'string' || !option.value.trim() || /,|<>|\+\+/.test(option.value) || values.has(option.value)) return null;
            ids.add(option.variant_id); values.add(option.value); references.add(option.variant_id);
            if (option.price_variant_id !== undefined) {
              if (!/^\d+$/.test(option.price_variant_id)) return null;
              references.add(option.price_variant_id);
            }
          }
        }
        if (data.base_variants !== undefined) {
          if (!Array.isArray(data.base_variants) || data.base_variants.length > 40) return null;
          const titles = new Set();
          for (const base of data.base_variants) {
            if (!base.parent_title || titles.has(base.parent_title) || !/^\d+$/.test(base.variant_id)) return null;
            titles.add(base.parent_title); references.add(base.variant_id);
          }
        }
        if (references.size > 128) return null;
        return { groups: data.groups.map(g => g.name), types: data.groups.map(() => 'native'), native: data.groups };
      } catch (_) { return null; }
    }
    kitStock(selects, profile) {
      const stockNode = this.querySelector('[data-kit-parent-stock]');
      if (!stockNode) return 0; // No component inventory evidence: keep purchase closed.
      let parent;
      try { parent = Number(JSON.parse(stockNode.textContent)[this.variant?.id]); } catch (_) { return 0; }
      const pool = Number(this.querySelector('[data-kit-capacity]')?.dataset.kitCapacity);
      if (!Number.isFinite(parent) || !Number.isFinite(pool)) return 0;
      const demands = new Map();
      selects.forEach((select, i) => {
        const option = select.selectedOptions[0], id = option?.dataset.component || option?.value;
        const units = profile?.native?.[i]?.quantity || 1;
        const stock = Number(option?.dataset.stock);
        const previous = demands.get(id);
        demands.set(id, { units: (previous?.units || 0) + units, stock: Math.min(previous?.stock ?? Infinity, Number.isFinite(stock) ? stock : 0) });
      });
      return Math.max(0, Math.min(parent, pool, ...[...demands.values()].map(d => Math.floor(d.stock / d.units))));
    }
    kitSelection(select, option) {
      const profile = this.kitProfile();
      const selects = [...this.querySelectorAll('[data-kit-pad],[data-kit-sock],[data-kit-generic]')];
      const index = selects.indexOf(select), group = profile?.groups[index];
      const id = option.dataset.component || option.value;
      let value = null;
      switch (profile?.types[index]) {
        case 'native': value = profile.native[index].options.find(o => o.variant_id === id)?.value; break;
        case 'pad':
          value = kitPads[id];
          // The four unavailable FOAM choices have no verified component.
          // Do not turn them into EVA, even though v2 also lists EVA.
          if (this.variant.id == 48218891944272 && value?.startsWith('EVA ')) value = null;
          if (value) value = (profile.padPrefix || '') + value;
          break;
        case 'sock':
          value = kitSocks[id];
          if (value) value = (profile.sockPrefix || '') + (value === 'Blanco' && profile.white ? profile.white : value);
          break;
        case 'precut': value = kitPrecuts[id]; break;
        case 'short': value = kitShortSocks[id]; break;
      }
      return { group, value };
    }
    kitSchema() {
      const profile = this.kitProfile();
      if (!profile) return null;
      if (profile.native) return profile.native.map(g => [{ optionName: g.name, optionValues: g.options.map(o => o.value).join(',') }]);
      const embedded = this.querySelector('[data-kit-contract]');
      // Liquid emits the current variant metafields; the app is a fallback for older preview HTML.
      try {
        const contracts = embedded && JSON.parse(embedded.textContent);
        // A partial/corrupt contract is not the same as Shopify's explicit null after removal.
        if (embedded && !Object.hasOwn(contracts, this.variant?.id)) return null;
        const schema = embedded ? contracts[this.variant?.id] : window.SimpleBundles?.productVariants?.[this.variant?.id]?.variant_options_v2;
        if (schema != null) return schema;
        // Audited legacy profiles remain usable after the app/metafields are removed.
        const selects = [...this.querySelectorAll('[data-kit-pad],[data-kit-sock],[data-kit-generic]')];
        return profile.groups.map((group, i) => [{ optionName: group,
          optionValues: [...(selects[i]?.options || [])].map(o => this.kitSelection(selects[i], o).value).filter(Boolean).join(',') }]);
      }
      catch (_) { return null; }
    }
    isolateKitApp() {
      // Give the app its documented mount OUTSIDE the owned form. Its v1 selects must
      // never become successful controls or precede our canonical v2 fields.
      let mount = this.querySelector('[data-simple-bundles-options]');
      if (!mount) { mount = document.createElement('div'); mount.dataset.simpleBundlesOptions = ''; }
      if (mount.parentElement !== this.form.parentElement || this.form.contains(mount)) this.form.before(mount);
      mount.hidden = true;
    }
    writeKitProperties(props) {
      const box = this.querySelector('[data-kit-properties]');
      box.replaceChildren();
      Object.entries(props).forEach(([key, value]) => {
        const input = document.createElement('input'); input.type = 'hidden';
        input.name = `properties[${key}]`; input.value = value;
        // The captured app writes .value synchronously on rehydration. Protect just
        // these owned fields, including direct reads before any observer/submit runs.
        // A new selection replaces the nodes; native FormData reads the same value.
        Object.defineProperty(input, 'value', { get: () => String(value), set: () => {} });
        box.append(input);
      });
      // Reserve disabled sinks for translated/legacy v1 names before the app's
      // synchronous writes. They are never successful form controls.
      let v1;
      try {
        const embedded = this.querySelector('[data-kit-v1-contract]');
        v1 = embedded ? JSON.parse(embedded.textContent)[this.variant?.id] : window.SimpleBundles?.productVariants?.[this.variant?.id]?.variant_options;
      } catch (_) { v1 = null; }
      const legacyNames = [...new Set([
        ...(Array.isArray(v1) ? v1.map(group => group?.optionName).filter(Boolean) : []),
        ...(this.kitProfile()?.groups || [])
      ])];
      legacyNames.forEach(name => {
        if (Object.hasOwn(props, name)) return;
        const input = document.createElement('input'); input.type = 'hidden';
        input.name = `properties[${name}]`; input.disabled = true; box.append(input);
      });
      this.kitProperties = props;
      // Remove stale app/v1 copies, including hidden inputs outside its mount.
      const names = new Set([...Object.keys(props), ...legacyNames].map(key => `properties[${key}]`));
      const schema = this.kitSchema();
      if (Array.isArray(schema)) schema.flat().forEach(group => { if (group?.optionName) names.add(`properties[${group.optionName}]`); });
      this.querySelectorAll('[data-kit-generic]').forEach(select => names.add(`properties[${select.dataset.property}]`));
      this.form.querySelectorAll('[name]').forEach(input => {
        if (!box.contains(input) && names.has(input.name)) input.remove();
      });
    }
    updateKit() {
      if (this.dataset?.mystery === 'true') {
        // Old Simple Bundles metadata may still rehydrate. Keep its UI outside
        // the form and its known fields unsuccessful, including direct app COD reads.
        this.isolateKitApp();
        const names = new Set([...this.querySelectorAll('[data-mystery-app] [name]')].map(input => input.name));
        this.form.querySelectorAll('[name]').forEach(input => { if (names.has(input.name)) input.disabled = true; });
        return;
      }
      const kit = this.querySelector('[data-kit]'); if (!kit) return;
      this.isolateKitApp();
      const props = {}, ids = [], chosenValues = new Map();
      const schema = this.kitSchema();
      const validSchema = Array.isArray(schema) && schema.length > 0 && schema.every(group =>
        Array.isArray(group) && group.length > 0 && group.every(option =>
          option && typeof option.optionName === 'string' && option.optionName && typeof option.optionValues === 'string' && option.optionValues));
      const groups = validSchema ? schema.flat() : [];
      const selects = [...kit.querySelectorAll('[data-kit-pad],[data-kit-sock],[data-kit-generic]')];
      const allowed = new Map(groups.map(group => [group.optionName, new Set(typeof group.optionValues === 'string' ? group.optionValues.split(',').map(value => value.trim()) : [])]));
      const profile = this.kitProfile();
      this.kitValid = validSchema && allowed.size === groups.length && selects.length === groups.length &&
        profile?.groups.length === schema.length && schema.every((group, i) => group.length === 1 && group[0].optionName === profile.groups[i]);
      selects.forEach(select => {
        const selected = select.selectedOptions[0];
        [...select.options].forEach(option => {
          const mapped = this.kitSelection(select, option);
          const eligible = Boolean(mapped.value && allowed.get(mapped.group)?.has(mapped.value));
          // Restore only disables owned by this validator. Stock/manual disables remain.
          if (option.dataset.contractDisabled === 'true') { option.disabled = false; delete option.dataset.contractDisabled; }
          if (!eligible && !option.disabled) { option.disabled = true; option.dataset.contractDisabled = 'true'; }
        });
        // Disabling an option must never silently choose a different component.
        if (selected) selected.selected = true;
        const mapped = selected && this.kitSelection(select, selected);
        if (!selected || selected.disabled || !mapped?.value || !allowed.get(mapped.group)?.has(mapped.value) ||
            ![...select.options].some(option => !option.disabled)) this.kitValid = false;
      });
      this.kitCapacity = this.kitStock(selects, profile);
      if (this.kitCapacity < (this.quantity || 1)) this.kitValid = false;
      const stockLabel = this.querySelector('[data-stock]');
      if (stockLabel && this.config?.strings) {
        const available = this.variant?.available && this.kitCapacity >= (this.quantity || 1);
        stockLabel.textContent = available ? this.config.strings.available : this.config.strings.sold_out;
        stockLabel.parentElement.classList.toggle('is-out', !available);
      }
      const pad = kit.querySelector('[data-kit-pad]');
      if (pad) {
        const chosen = pad.selectedOptions[0];
        // The kit cover is a rotating GIF; show the selected component on load too.
        if (chosen?.dataset.image && this.kitCoverModel !== chosen.dataset.model) {
          this.kitCoverModel = chosen.dataset.model;
          const cover = this.querySelector('[data-gallery] img');
          const thumb = this.querySelector('[data-thumb] img');
          const src = chosen.dataset.cover || chosen.dataset.image;
          [cover, thumb].forEach(img => { if (img) { img.removeAttribute('srcset'); img.src = src; img.alt = chosen.dataset.modelLabel; } });
          const first = this.querySelector('[data-gallery]>[data-slide]');
          if (first) this.showSlide?.(first.dataset.slide);
        }
      }
      this.kitViews?.forEach(sync => sync());
      let sum = 0, pricesKnown = true;
      if (profile?.native && kit.dataset.dreamer === 'true') {
        try {
          const data = JSON.parse(this.querySelector('[data-kit-profile]').textContent);
          const base = data.base_variants?.find(b => b.parent_title === this.variant.title);
          const components = JSON.parse(kit.querySelector('[data-kit-components]').textContent);
          const component = components[base?.variant_id];
          // Base artwork is not in _kit_variantes: keep the stock guard, but never
          // add an unlisted component to the separate-price comparison.
          pricesKnown = Number.isInteger(component?.price) && component.price >= 0;
          if (!pricesKnown || component.stock < (this.quantity || 1)) this.kitValid = false;
        } catch (_) { pricesKnown = false; this.kitValid = false; }
      }
      const summary = kit.querySelector('[data-kit-summary]'); summary.replaceChildren();
      const propertyLabels = JSON.parse(kit.querySelector('[data-kit-labels]').textContent);
      selects.forEach((select, index) => {
        const o = select.selectedOptions[0]; if (!o) return;
        const price = Number(o.dataset.price);
        if (!o.dataset.price || !Number.isSafeInteger(price) || price < 0) pricesKnown = false;
        const units = profile?.native?.[index]?.quantity || 1;
        sum += (price || 0) * units;
        const step = select.closest('fieldset');
        step?.classList.toggle('is-complete', !o.disabled && Boolean(select.value));
        const line = document.createElement('li');
        const label = (o.dataset.summaryLabel || o.dataset.productTitle || o.dataset.label || o.dataset.choiceLabel || o.textContent.trim()).replace(/\bCM\b/g, 'cm');
        line.textContent = `${index + 1} · ${units > 1 ? units + ' × ' : ''}${label}${o.dataset.price ? ' · ' + this.money(price * units) : ''}`;
        summary.append(line);
        const mapped = this.kitSelection(select, o); chosenValues.set(mapped.group, mapped.value);
        const propertyKey = kit.dataset.dreamer === 'true' && mapped.group === 'Calcetines Antideslizantes' ? 'socks' : kitPropertyNames[mapped.group];
        const propertyName = propertyLabels[propertyKey] || propertyLabels.component.replace('{{ number }}', index + 1);
        props[propertyName] = `${units > 1 ? units + ' × ' : ''}${o.dataset.orderLabel || o.dataset.choiceLabel || o.textContent.trim()}`;
        if (select.matches('[data-kit-generic]')) { if (o.dataset.component) ids.push(...Array(units).fill(o.dataset.component)); }
        else ids.push(o.value);
      });
      props._bundle_selection = this.kitValid ? schema.map(group => group.map(option => chosenValues.get(option.optionName)).join(' ++ ')).join(' <> ') : '';
      props._kit_variantes = ids.join(',');
      // Empty locked fields on failure prevent the app from installing its defaults.
      this.writeKitProperties(this.kitValid ? props : Object.fromEntries(Object.keys(props).map(key => [key, ''])));
      let error = kit.querySelector('[data-kit-error]');
      if (!error) { error = document.createElement('p'); error.dataset.kitError = ''; error.className = 'tbp-error'; error.setAttribute('role', 'alert'); kit.append(error); }
      error.textContent = kit.dataset.invalidMessage || 'Questo kit non è disponibile: una delle opzioni non è configurata correttamente. Contattaci per assistenza.';
      error.hidden = this.kitValid;
      const anchor = kit.querySelector('[data-kit-anchor]'); if (anchor) anchor.hidden = !pricesKnown || sum <= this.variant.price;
      const head = this.querySelector('[data-separate-head]'); if (head) { head.hidden = !pricesKnown || sum <= this.variant.price; this.querySelector('[data-separate-price]').textContent = this.money(sum); }
      const value = kit.querySelector('[data-kit-value]'); if (value) value.textContent = this.money(sum);
      const saving = kit.querySelector('[data-kit-saving]'); if (saving) { saving.textContent = this.money(Math.max(0, sum - this.variant.price)); saving.parentElement.hidden = !pricesKnown || sum <= this.variant.price; }
    }
    guard() {
      if (this.dataset.initError === 'true') return;
      const editor = this.querySelector('tb-a-editor');
      const complete = this.dataset.custom !== 'true' || editor?.valid?.();
      if (complete && editor) editor.querySelector('[data-editor-error]').hidden = true;
      const kit = this.querySelector('[data-kit]');
      const kitValid = !kit || (this.kitValid === true && !kit.querySelector('[data-kit-blocked]') && [...kit.querySelectorAll('select')].every(s => s.value && !s.selectedOptions[0]?.disabled));
      this.querySelector('[data-add]').disabled = this.busy || !this.variant?.available || !complete || !kitValid;
      // A missing required choice keeps the bar live: it leads to that choice instead of going dead.
      const missing = !this.busy && this.missingOption();
      this.querySelector('[data-sticky]').disabled = !missing && (this.busy || !this.variant?.available || !kitValid);
    }
    missingOption() {
      if (!this.variant) return [...this.querySelectorAll('[data-option]')].find(group => !group.querySelector('input:checked')) || null;
      const kit = this.querySelector('[data-kit]');
      const select = kit && [...kit.querySelectorAll('select')].find(s => !s.value);
      return select ? select.closest?.('fieldset') || select : null;
    }
    markMissing(el) {
      el.dataset.missing = '';
      el.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      (el.querySelector('input:not(:disabled),select,button:not(:disabled)') || el).focus({ preventScroll: true });
    }
    showIncomplete() {
      const editor = this.querySelector('tb-a-editor');
      const message = editor?.missing?.() || this.config.strings.incomplete;
      const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false;
      const notice = editor?.querySelector('[data-editor-error]');
      if (notice) { notice.textContent = message; notice.hidden = false; }
      window.TBOpenStudio?.(editor);
    }
    async readCart(limit = 15000) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), limit);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal: controller.signal });
        if (!response.ok) throw new Error(this.config.strings.upload_error);
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    uploadStatus(message,percent) {
      const editor=this.querySelector('tb-a-editor'), status=this.querySelector('[data-upload-status]');
      if(editor?.dialog?.open&&editor.uploadProgress){status.hidden=true;editor.uploadProgress(message,percent);}
      else{status.hidden=!message;status.textContent=message||'';}
    }
    upload(data, limit = 300000) {
      this.uploadStatus(this.config.strings.upload_progress.replace('{{ percent }}', '0'),0);
      return new Promise((resolve, reject) => {
        // At most 24 MiB including PNG: ~202 s at 1 Mbps, plus processing margin.
        const xhr = new XMLHttpRequest(); xhr.open('POST', this.form.action); xhr.timeout = Math.min(300000, limit);
        let announced = -1;
        xhr.upload.onprogress = event => {
          if (!event.lengthComputable) return;
          const percent = Math.floor(event.loaded / event.total * 10) * 10;
          if (percent === announced) return; announced = percent;
          this.uploadStatus(percent === 100 ? this.config.strings.upload_processing : this.config.strings.upload_progress.replace('{{ percent }}', percent),percent);
        };
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 400) return resolve();
          let body; try { body = JSON.parse(xhr.responseText); } catch (_) {}
          const rejected = xhr.status >= 400 && xhr.status < 500;
          const message = rejected && typeof body?.description === 'string' ? body.description : this.config.strings.upload_error;
          reject(Object.assign(new Error(message), { rejected, buyerMessage: rejected }));
        };
        xhr.onerror = () => reject(Object.assign(new Error(this.config.strings.upload_network), { retryable: true }));
        xhr.ontimeout = () => reject(Object.assign(new Error(this.config.strings.upload_timeout), { retryable: true }));
        xhr.send(data);
      });
    }
    uploadJournal() {
      this.uncertainUploads ||= new Set();
      this.uploadEntries ||= {};
      try {
        const saved = JSON.parse(sessionStorage.getItem('tb-upload-pending:' + this.dataset?.productId) || '{}');
        for (const [id, entry] of Object.entries(saved)) {
          this.uncertainUploads.add(id); this.uploadEntries[id] = entry;
        }
      } catch (_) { /* Keep the in-memory journal if storage is unavailable. */ }
      for (const id of this.uncertainUploads) {
        if (!(this.uploadEntries[id]?.expiresAt > Date.now())) {
          this.uncertainUploads.delete(id); delete this.uploadEntries[id];
        }
      }
      this.saveUploadJournal();
    }
    saveUploadJournal() {
      try {
        sessionStorage.setItem('tb-upload-pending:' + this.dataset?.productId, JSON.stringify(this.uploadEntries));
      } catch (_) { /* Storage is optional; current-page protection remains. */ }
    }
    async uploadEditor(data, uploadId, editor) {
      this.ownUploadConfirmed = null;
      // One multipart POST per action, with a six-minute request budget.
      // The final reconciliation read still runs if that budget is exhausted.
      const deadline = Date.now() + 360000;
      const remaining = () => Math.max(1, deadline - Date.now());
      const matches = (cart, id) => cart.items.filter(item => item.properties?._tb_upload_id === id);
      let allowUnverified = false;
      this.uploadJournal();
      const forget = id => { this.uncertainUploads.delete(id); delete this.uploadEntries[id]; this.saveUploadJournal(); };
      // Only this action's R2 POST may repair quantities. Recovery can detect a
      // mismatch, but cannot distinguish a late duplicate from a customer's edit.
      const expectedQuantity = editor.privateStorage ? Number(data.get('quantity')) : undefined;
      const recordedQuantity = id => editor.privateStorage && this.uploadEntries[id]?.ownPost === true &&
        Object.hasOwn(this.uploadEntries[id], 'expectedQuantity');
      const reconcile = async (id, wait, ownPost = false) => {
        let cart, lastError;
        // The window is 31 seconds of pauses. Reads have their own timeout,
        // and the final read always runs, even on a slow connection.
        for (const delay of wait ? [0,1000,2000,4000,8000,16000] : [0]) {
          if (delay) await new Promise(resolve => setTimeout(resolve, delay));
          try { cart = await this.readCart(Math.min(15000, remaining())); lastError = null; }
          catch (error) { lastError = error; }
        }
        if (lastError || !cart) throw lastError || new Error(this.config.strings.upload_network);
        const lines = matches(cart, id);
        if (lines.length) {
          // In R2, only this action's own POST may change the cart: any other
          // read leaves same-ID lines alone, including after the quantity warning.
          if (!ownPost && editor.privateStorage) return cart;
          const checkQuantity = ownPost && editor.privateStorage;
          if (checkQuantity && (!Number.isSafeInteger(expectedQuantity) || expectedQuantity < 1)) throw new Error(this.config.strings.cart_repair_error);
          // Identical R2 properties merge repeated submissions into one 2q line.
          const repairQuantity = checkQuantity && lines[0].quantity !== expectedQuantity;
          if (repairQuantity) await this.changeLine(lines[0].key, expectedQuantity, remaining());
          for (const line of lines.slice(1)) await this.changeLine(line.key, 0, remaining());
          if (repairQuantity || lines.length > 1) cart = await this.readCart(Math.min(15000, remaining()));
          const left = matches(cart, id);
          if (left.length !== 1 || (checkQuantity && left[0].quantity !== expectedQuantity)) throw new Error(this.config.strings.cart_repair_error);
        }
        return cart;
      };
      const warn = id => {
        this.uploadEntries[id].warned = true;
        this.saveUploadJournal();
        return Object.assign(new Error(this.config.strings.upload_uncertain), { cartLink: true });
      };
      for (const id of this.uncertainUploads) {
        if (this.uploadEntries[id].warned) {
          allowUnverified = true;
        }
        let cart;
        try { cart = await reconcile(id, !this.uploadEntries[id].warned); }
        catch (_) { if (!allowUnverified) throw warn(id); forget(id); continue; }
        const lines = matches(cart, id);
        if (lines.length) {
          if (recordedQuantity(id) && (lines.length !== 1 || lines[0].quantity !== this.uploadEntries[id].expectedQuantity)) {
            forget(id);
            throw Object.assign(new Error(this.config.strings.upload_quantity_review), { cartLink: true });
          }
          forget(id);
          if (id === uploadId) return cart;
          if (this.selectedExtras().length) this.warnExtras(id);
          throw new Error(this.config.strings.upload_recovered);
        }
        forget(id);
      }
      let existing;
      try { existing = await reconcile(uploadId, false); }
      catch (error) { if (!allowUnverified) throw error; existing = { items: [] }; }
      if (matches(existing, uploadId).length) return existing;
      if (remaining() <= 45000) throw new Error(this.config.strings.upload_timeout);
      this.uncertainUploads.add(uploadId);
      this.uploadEntries[uploadId] = { expiresAt: Date.now() + 600000, warned: false };
      if (editor.privateStorage) Object.assign(this.uploadEntries[uploadId], { expectedQuantity, ownPost: true });
      this.saveUploadJournal();
      try {
        try{await this.upload(data,Math.min(300000,remaining()-45000));}
        catch(error){
          // Only an explicit rejection permits another POST. Ambiguous responses still reconcile.
          const optional=['properties[_tb_bleed_L]','properties[_tb_bleed_R]'];
          if(editor.privateStorage||!error.rejected||remaining()<=45000||!optional.some(k=>data.has(k)))throw error;
          optional.forEach(k=>data.delete(k));await this.upload(data,Math.min(300000,remaining()-45000));
        }
      }
      catch (error) {
        if (error.rejected || error.retryable === false) { forget(uploadId); throw error; }
        this.uploadStatus(editor.strings.retrying);
        let cart;
        try { cart = await reconcile(uploadId, true, true); }
        catch (_) { throw warn(uploadId); }
        if (matches(cart, uploadId).length) { forget(uploadId); this.ownUploadConfirmed = uploadId; return cart; }
        // Retain the ID for the next action: a response may arrive after this window.
        throw warn(uploadId);
      }
      let cart;
      try { cart = await reconcile(uploadId, false, true); }
      catch (_) { throw warn(uploadId); }
      if (matches(cart, uploadId).length) { forget(uploadId); this.ownUploadConfirmed = uploadId; return cart; }
      throw warn(uploadId);
    }
    async changeLine(key, quantity, limit = 15000) {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), Math.min(15000, limit));
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', signal: controller.signal, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        if (!response.ok) throw new Error(this.config.strings.cart_repair_error);
        const cart = await response.json();
        const line = cart.items?.find(item => item.key === key);
        if (!Array.isArray(cart.items) || (quantity === 0 ? Boolean(line) : line?.quantity !== quantity)) throw new Error(this.config.strings.cart_repair_error);
      } finally { clearTimeout(timer); }
    }
    async removeIncomplete(key) {
      for (let attempt = 0; attempt < 3; attempt++) {
        try { await this.changeLine(key, 0); } catch (_) { /* Verify a lost response too. */ }
        try { if (!(await this.readCart()).items.some(item => item.key === key)) return; } catch (_) { /* Retry safely by key. */ }
        if (attempt < 2) await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)));
      }
      throw new Error(this.config.strings.cart_repair_error);
    }
    async submit(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.busy) return;
      const error = this.querySelector('[data-error]'); error.hidden = true;
      const extraError = this.querySelector('[data-extra-error]'); if (extraError) extraError.hidden = true;
      const extraRecover = this.querySelector('[data-extra-recover]'); if (extraRecover) extraRecover.hidden = true;
      const editor = this.querySelector('tb-a-editor');
      if (this.dataset.custom === 'true' && !editor?.valid?.()) { this.showIncomplete(); return; }
      this.updateKit();
      if (this.querySelector('[data-kit]') && !this.kitValid) { this.guard(); return; }
      if (!this.variant?.available || this.querySelector('[data-add]').disabled || !this.form.reportValidity()) return;
      this.busy = true; this.form.inert = true; this.guard();
      try {
        // The same validated properties are already readable before submit.
        const data = new FormData(this.form); data.set('quantity', this.quantity);
        this.form.querySelectorAll('[data-kit-properties] input[name]:not(:disabled)').forEach(input => data.set(input.name, input.value));
        const kitSelection = [...this.form.querySelectorAll('[data-kit-properties] input[name]:not(:disabled)')].map(input => [input.name,input.value]).sort(([a],[b]) => a.localeCompare(b));
        const designKey = editor ? JSON.stringify([editor.revision, this.variant.id, this.quantity, kitSelection]) : null;
        const uploadId = editor ? (this.pendingDesign?.key === designKey ? this.pendingDesign.id : crypto.randomUUID()) : null;
        if (editor) this.pendingDesign = { key: designKey, id: uploadId };
        if (uploadId) data.set('properties[_tb_upload_id]', uploadId);
        const kitReturn = Boolean(editor && typeof location !== 'undefined' && new URLSearchParams(location.search).get('tb_kit') === '1');
        if (kitReturn) {
          data.set('properties[_tb_kit_custom]', '1');

        }
        if (editor) {this.uploadStatus(editor.ui?.preparing||this.config.strings.loading);await editor.appendFiles(data);}
        // Native multipart endpoint preserves original image files in line properties.
        let cart;
        const extra = this.selectedExtras();
        if (editor) cart = await this.uploadEditor(data, uploadId, editor);
        else {
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') properties[match[1]] = value;
          }
          const item = { id: this.variant.id, quantity: this.quantity, properties };
          if (this.dataset.mystery === 'true' && !Object.keys(properties).length) delete item.properties;
          cart = await this.standardItems([item, ...extra.map(v => ({ id: v.id, quantity: 1 }))]);
        }
        const line = cart.items.find(item => item.variant_id === this.variant.id && (!uploadId || item.properties?._tb_upload_id === uploadId));
        if (!line) throw new Error(this.config.strings.upload_error);
        if (editor) {
          const required = editor.printVersion === 3 || editor.mode === 'photo' ? ['Foto L', 'Foto R', 'Anteprima finale'] : ['Anteprima finale'];
          if(editor.printVersion===3&&!editor.privateStorage)for(const [key,value] of data)if(value instanceof Blob){const property=/^properties\[(.*)\]$/.exec(key)?.[1];if(property&&!property.startsWith('_tb_bleed_')&&!required.includes(property))required.push(property);}
          const uploaded = editor.privateStorage ? editor.r2?.matchesLine(line) : required.every(key => typeof line.properties?.[key] === 'string' && /(?:cdn\.shopify\.com|\/uploads\/)/.test(line.properties[key]));
          if (!uploaded) {
            await this.removeIncomplete(line.key);
            throw new Error(this.config.strings.upload_error);
          }
        }
        if(editor&&window.TBLocalDesign){await window.TBLocalDesign.put(uploadId,this.dataset.productId,editor.localPair,this.variant.id);await window.TBLocalDesign.remove('ready:'+editor.draftToken);}
        await editor?.clearDraft?.();
        if (editor) cart = await this.customExtraOnce(uploadId, extra, cart);
        this.pendingDesign = null;
        if (kitReturn) {
          try { localStorage.setItem('tb-cart-change', `${Date.now()}:${Math.random()}`); } catch (_) {}
          const warning = extraError && !extraError.hidden ? extraError.textContent : '';
          try { if (warning) sessionStorage.setItem('tb-kit-return-warning', warning); } catch (_) { if (warning) return; }
          const handle = document.querySelector('tb-a-cart')?.config?.kitCollectionHandle || 'packs-calcio-risparmia';
          window.location.assign(`${window.Shopify?.routes?.root || '/'}collections/${handle}?view=crea-kit`);
          return;
        }
        document.dispatchEvent(new CustomEvent('tb:cart:updated', { detail: cart, bubbles: true }));
        document.dispatchEvent(new CustomEvent('tb:cart:added', { detail: { cart, item: line, warning: extraError && !extraError.hidden ? extraError.textContent : '' } }));
        if (!document.querySelector('tb-a-cart')) window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (e) {
        error.textContent = (e.buyerMessage || Object.values(this.config.strings).includes(e.message) || Object.values(editor?.ui||{}).includes(e.message) || Object.values(editor?.r2?.strings||{}).includes(e.message)) ? e.message : this.config.strings.upload_network;
        if (e.cartLink) {
          const link = document.createElement('a');
          link.href = `${window.Shopify?.routes?.root || '/'}cart`;
          link.textContent = this.config.strings.upload_cart_link;
          error.append(' ', link);
        }
        error.hidden = false;
      }
      finally { this.busy = false; this.form.inert = false; this.uploadStatus(''); this.guard(); }
    }
  }
  customElements.define('tb-a-product', Product);
})();
